import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerTypeService {

  constructor(private ws: PostmethodService) { }

  customerTypeCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "customerTypeMaster");
  }
}
